import Vue from 'vue';
// @ts-ignore
import Input from 'buefy';
// @ts-ignore
import Button from 'buefy';
// @ts-ignore
import Field from 'buefy';
// @ts-ignore
import Datepicker from 'buefy';
// @ts-ignore
import Tooltip from 'buefy';
// @ts-ignore
import Dropdown from 'buefy';
// @ts-ignore
import Icon from 'buefy';
// @ts-ignore
import Toast from 'buefy';
// @ts-ignore
import Snackbar from 'buefy';
// @ts-ignore
import Radio from 'buefy';
// @ts-ignore
import Loading from 'buefy';
// @ts-ignore
import Notification from 'buefy';

Vue.use(Field);
Vue.use(Button);
Vue.use(Input);
Vue.use(Tooltip);
Vue.use(Dropdown);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Radio);
Vue.use(Datepicker);
Vue.use(Snackbar);
Vue.use(Notification);
Vue.use(Loading);
